module.exports = __webpack_public_path__ + "KW.png?8ec6e2cd34e6b83d0ce5ed905d5ccce6";